export default "/048cb1f2b29308e18768c65cfd51e426596a830c/5860effcda061f4f05feb4a92be5a34c.svg";